import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import logo from '../../../assets/images/logo-ghs.svg';
import { black } from 'variables/colors';
import { getMe } from 'api/auth';

const Page = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const Content = styled.div`
  text-align: center; ;
`;

const Logo = styled.img`
  width: 5em;
  animation: loadingSpin 2s infinite;

  @keyframes loadingSpin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const LoadingText = styled.h3`
  margin-top: 1.5em;
  color: ${black};
`;

const Loading = () => {
  const history = useHistory();

  useEffect(async () => {
    const token = localStorage.getItem('token');

    if (token) {
      try {
        await getMe();
      } catch (error) {
        localStorage.removeItem('token');
        history.go(0);
      }
    }
  }, []);

  return (
    <Page>
      <Content>
        <Logo src={logo} />
        <LoadingText>Loading...</LoadingText>
      </Content>
    </Page>
  );
};

export default Loading;
